import { render, staticRenderFns } from "./comAtCenter.vue?vue&type=template&id=471dc058&scoped=true&"
import script from "./comAtCenter.vue?vue&type=script&lang=js&"
export * from "./comAtCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471dc058",
  null
  
)

export default component.exports